/**
 * Check if the current url path is whitelisted.
 * 
 * @function 
 * @name isWhitelisted
 * @param {Array} whiteListedPaths
 * @returns {boolean} - Returns true if the path is whitelisted; otherwise, false.
 */
export const isWhitelisted = (whiteListedPaths: string[]): boolean => {
    const currentURL = window.location.href;
    const isMatch = whiteListedPaths.some((path: string) => {
        return path === currentURL;
    });
    console.log(`UNIVERSAL ID: Is this page whitelisted? - ${isMatch}`)
    return isMatch;
};